import React, {useState} from 'react';
import { Redirect } from 'react-router-dom';
import PersonSelects from "./PersonSelects";

interface Step2aProps {
  persons: string[];
  setPersons: React.Dispatch<React.SetStateAction<string[]>>;
  pSNr: {[key: string]: number};
  setPSNr: React.Dispatch<React.SetStateAction<{[key: string]: number}>>;
  s: {[key: string]: string[]};
  setS: React.Dispatch<React.SetStateAction<{[key: string]: string[]}>>;
  setInp: React.Dispatch<React.SetStateAction<{[key: string]: string}>>;
}

function Step2a(props: Step2aProps) {
  const { persons, setPersons, pSNr, setPSNr, s, setS, setInp } = props;

  const [redirectTo, setRedirectTo] = useState<string|undefined>(undefined);

  const allFieldFilled = (ids: string[]) => {
    return ids.map((id) => {
      return s[id].filter((f) => f !== '-').length > 0;
    }).every((value) => value);
  }

  const redirect = (e: React.MouseEvent<HTMLButtonElement>, to: string) => {
    e.preventDefault();

    if (!allFieldFilled(['4', '5', '6', '7', '8', '9', '10'])) {
      alert('Bitte alle Felder ausfüllen.');
      return;
    }

    setRedirectTo(to);
  };

  const redirectBack = (e: React.MouseEvent<HTMLButtonElement>, to: string) => {
    e.preventDefault();

    setPersons([]);
    setPSNr({
      '4': 1,
      '5': 1,
      '6': 1,
      '7': 1,
      '8': 1,
      '9': 1,
      '10': 1,

      '12': 1,
      '13': 1,
      '14': 1,
      '15': 1,
      '16': 1,

      '18': 1,
      '19': 1,
      '20': 1,
      '21': 1,
    });
    setS({
      '4': ['-', '-', '-', '-'],
      '5': ['-', '-', '-', '-'],
      '6': ['-', '-', '-', '-'],
      '7': ['-', '-', '-', '-'],
      '8': ['-', '-', '-', '-'],
      '9': ['-', '-', '-', '-'],
      '10': ['-', '-', '-', '-'],

      '12': ['-', '-', '-', '-'],
      '13': ['-', '-', '-', '-'],
      '14': ['-', '-', '-', '-'],
      '15': ['-', '-', '-', '-'],
      '16': ['-', '-', '-', '-'],

      '18': ['-', '-', '-', '-'],
      '19': ['-', '-', '-', '-'],
      '20': ['-', '-', '-', '-'],
      '21': ['-', '-', '-', '-'],
    });
    setInp({
      '23': 'no',
      '24': 'no',
      '25': 'no',
      '26': 'no',
      '27': 'no',
    });

    setRedirectTo(to);
  };

  if (redirectTo !== undefined) {
    return (
      <Redirect to={redirectTo} />
    );
  }


  return (
    <div className="step step2a">
      <h2>Schritt 2: Zuständigkeiten</h2>

      <h3>A) Aufgaben</h3>

      <p>
        Geben Sie hier bitte jeweils die Personen oder Gruppen an, die für den jeweiligen Bereich
        die <strong>Entscheidungsbefugnis</strong> haben.
      </p>

      <form>
        <div className="personBlock">
          <p>
            Wer entscheidet darüber, ob ein Algorithmensystem eingeführt oder (weiter-)betrieben wird?
          </p>
          <PersonSelects id="4" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer entwickelt das System?
          </p>

          <PersonSelects id="5" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer implementiert das System?
          </p>

          <PersonSelects id="6" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer wendet das System an?
          </p>

          <PersonSelects id="7" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer ist für die laufende Sicherheit des Systems zuständig?
          </p>
          <PersonSelects id="8" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer verwaltet die Datenbasis, mit der das System arbeitet?
          </p>
          <PersonSelects id="9" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer evaluiert das System?
          </p>
          <PersonSelects id="10" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
      </form>

      <div className="stepNav">
        <button className="btn btn-secondary" onClick={(e) => redirectBack(e, '/step1')}>Neustart</button>
        <button className="btn btn-primary" onClick={(e) => redirect(e, '/step2b')}>Weiter</button>
      </div>
    </div>
  );
}

export default Step2a
;